import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import Providers from './components/Providers';
import * as serviceWorker from './serviceWorker';

const { hostname } = window.location;
let env = false;
if (hostname.indexOf('uat.') > -1) env = 'uat';
if (hostname.indexOf('test.') > -1) env = 'test';
if (hostname.indexOf('cremationmanager.com.au') > -1) env = 'live';
if (env) {
    Sentry.init({
        dsn: 'https://b6103898b810712fa5e40d0c019bebef@o4509227928911872.ingest.de.sentry.io/4509307504492624',
        environment: env,
        autoSessionTracking: true,
        sendDefaultPii: true,
        release: localStorage.getItem('commit_ref')
    });
}

const root = createRoot(document.getElementById('root'));
root.render(
    <Providers>
        <App />
    </Providers>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
